import { render, staticRenderFns } from "./InputBase.vue?vue&type=template&id=115aefd5&"
import script from "./InputBase.vue?vue&type=script&lang=js&"
export * from "./InputBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports